module.exports = __webpack_public_path__ + "img/merdeka-belajar.37f1b554.png";